const editProfile = {
  en: {
    translation: {
      edit_profile: "Edit Profile",
      complete_profile: "Complete your profile",
      update_profile: "Update profile",
      male: "Male",
      female: "Female",
      other: "Other",
      city_not_found: "City not found",
      saved_success_title: "Profile saved",
      saved_success_text: "Your profile has been updated, thank you",
      saved_error_title: "Oops",
      saved_error_text: "Something went wrong trying to update your profile",
      not_found: "Not found",
      add_favorite: "Add favourite",
      add_locality: "Add location",
      edit_profile_picture: "Edit profile picture",
      upload_image_error_title: "Oops",
      upload_image_error_text:
        "Something went wrong while trying to update the image, please try again later",
      restaurants_list: "Business list"
    }
  },
  it: {
    translation: {
      edit_profile: "Modifica Profilo",
      complete_profile: "Completa il tuo profilo",
      update_profile: "Aggiorna profilo",
      male: "Uomo",
      female: "Donna",
      other: "Altro",
      city_not_found: "Città non trovata",
      saved_success_title: "Profilo salvato",
      saved_success_text: "Il tuo profilo è stato aggiornato, grazie",
      saved_error_title: "Ops",
      saved_error_text:
        "Qualcosa è andato storto durante il salvataggio delle modifiche al tuo profilo",
      not_found: "Non trovato",
      add_favorite: "Aggiungi preferenza",
      add_locality: "Aggiungi città",
      edit_profile_picture: "Modifica l'immagine di profilo",
      upload_image_error_title: "Ops",
      upload_image_error_text:
        "Qualcosa è andato storto durante il caricamento dell'immagine, per favore riprova più tardi",
      restaurants_list: "Lista attività"
    }
  }
};

export default editProfile;
